import { useEffect, useRef } from 'react';

function usePrevious<T>(value: T): T | null {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    ref.current = value; // Update the ref value after each render
  });

  return ref.current;
}

export default usePrevious;
